import { makeStyles } from '@material-ui/core'
import {
  ERROR_COLORS,
  GRAY_COLORS,
  PRIMARY_COLORS,
  SUCCESS_COLORS,
  WARNING_COLORS
} from 'asterX-UI'

export const useStyles = makeStyles(theme => ({
  taskCardContent: {
    padding: '16px 24px'
  },
  overdueCard: {
    backgroundColor: ERROR_COLORS[50],
    border: `1px solid ${ERROR_COLORS[300]}`
  },
  csIssueManager: {
    backgroundColor: PRIMARY_COLORS[50],
    border: `1px solid ${PRIMARY_COLORS[350]}`
  },
  overdueChip: {
    backgroundColor: 'transparent',
    border: `1px solid ${ERROR_COLORS[700]}`,
    color: ERROR_COLORS[700],
    fontWeight: 500
  }
}))

export const useTaskModalStyles = makeStyles(() => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 16,
    marginBottom: 20
  },
  heading: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '24px'
  },
  infoBlock: {
    display: 'flex',
    alignItems: 'center',
    gap: 20,
    marginBottom: 12,
    fontSize: 14,
    fontWeight: 400
  },
  title: {
    width: 100,
    color: GRAY_COLORS['400']
  },
  text: {
    color: GRAY_COLORS['700'],
    maxWidth: 250
  },
  time: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    fontFamily: 'Inter',

    '&.expired': {
      color: ERROR_COLORS[500]
    },
    '&.today': {
      color: WARNING_COLORS[500]
    },
    '&.tomorrow': {
      color: SUCCESS_COLORS[500]
    }
  },
  btns: {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    width: '96%',
    bottom: 10
  },
  row: {
    display: 'flex',
    gap: 12
  },
  needs: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
    gap: 5,
    paddingBottom: 0
  },
  container: {
    height: '76vh',
    overflowY: 'auto'
  },
  errorBtn: {
    color: ERROR_COLORS[700],
    backgroundColor: ERROR_COLORS[100]
  }
}))
